import "./App.css";
import DashBoard from "./pages/dashboard";
//https://bgradecoding.tistory.com/14
function App() {
  return <DashBoard />;
}

export default App;
